import { useCallback } from 'react';
import { useBriefSubmittedMutation } from '../../graph';
import { OrphanedBriefError } from '../../lib/errors';
import { BriefType } from './useHandleSubmit';

export const useCartlessSubmit = () => {
    const [briefSubmittedMutation] = useBriefSubmittedMutation();

    return useCallback(
        async (data: BriefType): Promise<string> => {
            if (!data.request || !data.request.facts)
                throw new OrphanedBriefError(
                    `Encountered orphaned brief in useCartlessSubmit hook: ${data.id}`
                );

            const { id } = data.request;

            const { data: res, errors } = await briefSubmittedMutation({
                variables: { requestId: id, briefId: data.id },
            });

            if (errors && errors.length > 0) {
                throw new Error(
                    `useCartlessSubmission mutation failed: ${errors
                        .map((e) => e.message)
                        .join('; ')}`
                );
            }

            if (!res) throw new Error(`useCartlessSubmit: Failed to call to requests`);

            const next = res.addEvent_BriefSubmitted.facts?.currentUrl;

            if (!next)
                throw new Error(`useCartlessSubmit: response did not return a redirect route`);

            return next;
        },
        [briefSubmittedMutation]
    );
};
